import { isSeriesConferencePromo, isSessionConferencePromo } from '../lib/helpers'

export default function getIsPlaylistable({ contentType }) {
  return isSeriesConferencePromo({ contentType }) || isSessionConferencePromo({ contentType })
}
